import CardAmarelo from '../assets/images/tema_card_amarelo.svg'
import CardAzul from '../assets/images/tema_card_azul.svg'
import CardBege from '../assets/images/tema_card_bege.svg'
import CardCinza from '../assets/images/tema_card_cinza.svg'
import CardLaranja from '../assets/images/tema_card_laranja.svg'
import CardVerde from '../assets/images/tema_card_verde.svg'
import CardVerdeClaro from '../assets/images/tema_card_verde_claro.svg'

export const getRandomImage = () => {
  const card = {
    amarelo: CardAmarelo,
    azul: CardAzul,
    bege: CardBege,
    cinza: CardCinza,
    laranja: CardLaranja,
    verde: CardVerde,
    verdeClaro: CardVerdeClaro
  }
  const colors = Object.values(card)
  return colors[Math.floor(Math.random() * colors.length)]
}

export const converterParaBase64 = (
  file: File | undefined
): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader()

      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve(reader.result as string)
      }
      reader.onerror = () => {
        reject()
      }
    } else {
      resolve('')
    }
  })
}
